var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccess = function SvgSuccess(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FE04AC7E-2FD3-4626-8301-BD80BA0DD7A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Status/Success",
    fill: "#69A204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,-0.001 C24.836556,-0.001 32,7.162444 32,15.999 C32,24.835556 24.836556,31.999 16,31.999 C7.163444,31.999 0,24.835556 0,15.999 C0,7.162444 7.163444,-0.001 16,-0.001 Z M23.7071068,11.2928932 C23.3165825,10.9023689 22.6834175,10.9023689 22.2928932,11.2928932 L22.2928932,11.2928932 L14,19.585 L9.70710678,15.2928932 L9.61289944,15.2097046 C9.22060824,14.9046797 8.65337718,14.9324093 8.29289322,15.2928932 C7.90236893,15.6834175 7.90236893,16.3165825 8.29289322,16.7071068 L8.29289322,16.7071068 L13.2928932,21.7071068 L13.3871006,21.7902954 C13.7793918,22.0953203 14.3466228,22.0675907 14.7071068,21.7071068 L14.7071068,21.7071068 L23.7071068,12.7071068 L23.7902954,12.6128994 C24.0953203,12.2206082 24.0675907,11.6533772 23.7071068,11.2928932 Z",
    id: "Icon"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.aafe3c5443fc12f973799c679a8b1489.svg";